import { useState, useRef } from 'react';
import { hotSites } from '@/mocks/navigation';

export default function HotSites() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateScrollState = () => {
    if (!scrollRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 10);
  };

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const amount = 320;
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth',
    });
    setTimeout(updateScrollState, 350);
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-900">
                热门推荐
              </h2>
              <span className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-label font-semibold">
                HOT
              </span>
            </div>
            <p className="text-foreground-500 text-sm md:text-base mt-1">
              千万用户的选择，精选优质网站入口
            </p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className="w-9 h-9 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:border-foreground-500 hover:text-foreground-700 transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className="w-9 h-9 rounded-full bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          onScroll={updateScrollState}
          className="flex gap-4 overflow-x-auto scrollbar-hide pb-2 -mx-4 px-4 md:px-6 snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {hotSites.map((site) => (
            <a
              key={site.rank}
              href={site.url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex-shrink-0 w-[280px] snap-start bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-300 transition-all duration-200 group cursor-pointer"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 rounded-xl bg-background-100 flex items-center justify-center group-hover:bg-primary-50 transition-colors">
                  <i className={`${site.icon} text-xl text-foreground-600`}></i>
                </div>
                <span className="font-label font-bold text-lg text-accent-500">
                  {site.rating}
                </span>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-base mb-1">{site.name}</h3>
              <p className="text-foreground-500 text-xs">{site.category}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-foreground-400 font-label">
                  #{site.rank} 热度排名
                </span>
                <span className="text-xs text-primary-500 font-label font-medium group-hover:underline">
                  访问网站 →
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}